<template>
  <div>
    <div class="stockli__form-intro bkgr-sun">
      <div class="stockli__form-intro--text is-top black-trans-bkgr">
        <div class="h4 white-text mb-0">Release Preference</div>
      </div>
    </div>
    <v-container class="stockli__calculator-container">
      <div class="progress-indicator">
        <router-link to="/info">
          <div class="step-indicator active">Contact Info</div>
        </router-link>
        <div class="step-line active"></div>
        <div class="step-indicator active">Release Preference</div>
        <div class="step-line"></div>
        <div class="step-indicator">Your Setting</div>
        <div class="step-line"></div>
        <div class="step-indicator">Submit</div>
      </div>

      <v-form ref="form" @submit.prevent="Calculate" class="mb-5">
        <div class="h3">Indicator Setting Calculator</div>
        <v-row dense>
          <v-col cols="12">
            <v-select label="Weight" v-model="Weight" :items="enumWeight" item-value="text" :rules="[ruleRequired]" />
          </v-col>
          <v-col cols="12">
            <v-select label="Height" v-model="Height" :items="enumHeight" item-value="text" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-select label="Release Preference" v-model="Type_of_Skier" :items="enumTypeOfSkier" item-value="text" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="12">
            <v-select label="Boot Make" v-model="Boot_Make" :items="bootBrands" item-value="text" :rules="[ruleRequired]" />
          </v-col>
          <v-col cols="12">
            <v-text-field label="Sole Length (mm)" v-model="Sole" type="number" :rules="[ruleRequired, ruleSole]" />
          </v-col>
          <v-col cols="12">
            <v-select label="Sole Type" v-model="Sole_Type" :items="soleTypes" item-value="text" :rules="[ruleRequired]" />
          </v-col>
        </v-row>
        <v-btn type="submit" class="my-6">Calculate</v-btn>
      </v-form>
      <div class="skier-types-intro mb-5">
        <div class="h3">Choosing your release preference is your responsibility.</div>
        <p class="mb-6">
          The factors that determine the release setting on your ski bindings include
          your height, weight, age, boot sole length, and your personal release preference.
          You are responsible for determining your own release preference based upon the chart
          below and for informing the ski shop technician of your preference.
          Your ski shop technician cannot make this determination for you.
          Be sure to provide accurate information regarding your height, weight, age and personal release preference.
          Errors may increase your risk of injury.
        </p>
        <div class="h2">Release Preference</div>
        <hr class="mb-5" />
        <div class="skier-types__single-row flex-container top mb-4">
          <img src="@/styles/assets/skier-type-1.png" class="skier-types__single-row--image" />
          <div class="skier-types__single-row--description">
            <div class="h4">
              <span class="bold-text">TYPE I</span>: Entry-level skiers who are uncertain of their preference.
            </div>
            <p>
              Entry-level skiers and skiers who designate themselves as Type I receive
              <strong>lower than average ski binding release settings</strong>.
              This corresponds to easier ski binding release in a fall.
            </p>
          </div>
        </div>

        <div class="skier-types__single-row flex-container top mb-4">
          <img src="@/styles/assets/skier-type-2.png" class="skier-types__single-row--image" />
          <div class="skier-types__single-row--description">
            <div class="h4">
              <span class="bold-text">TYPE II</span>: Most skiers are satisfied with a Type II setting.
            </div>
            <p>Skiers who designate themselves as Type II receive average ski binding release settings appropriate for most recreational skiing.</p>
          </div>
        </div>

        <div class="skier-types__single-row flex-container top mb-4">
          <img src="@/styles/assets/skier-type-3.png" class="skier-types__single-row--image" />
          <div class="skier-types__single-row--description">
            <div class="h4">
              <span class="bold-text">TYPE III</span>: Skiers who designate themselves as a Type III receive
              <span class="bold-text">higher than average release settings</span>.
            </div>
            <p>
              This corresponds to decreased risk of inadvertent binding release and increased risk of non-release.
              This classification is not recommended for skiers 47 lbs. (21 kg) and under.
            </p>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";

import { GetIndicator } from "@/services/calculator";

export default {
  name: "Calculator",
  components: {
  },
  data: () => ({
    enumTypeOfSkier: [
      { text: "Type I", value: "1" },
      { text: "Type II", value: "2" },
      { text: "Type III", value: "3" },
    ],
    enumHeight: [
      { text: "≤ 4'10\"", value: 58 },
      { text: "4'11\" - 5'1\"", value: 60 },
      { text: "5'2\" - 5'5\"", value: 64 },
      { text: "5'6\" - 5'10\"", value: 69 },
      { text: "5'11\" - 6'4\"", value: 74 },
      { text: "≥ 6'5\"", value: 80 },
    ],
    enumWeight: [
      { text: "22-29 lbs / 10-13 kg", value: 25 },
      { text: "30-38 lbs / 13-17 kg", value: 34 },
      { text: "39-47 lbs / 17-21 kg", value: 44 },
      { text: "48-56 lbs / 22-25 kg", value: 52 },
      { text: "57-66 lbs / 26-30 kg", value: 62 },
      { text: "67-78 lbs / 30-35 kg", value: 72 },
      { text: "79-91 lbs / 36-41 kg", value: 84 },
      { text: "92-107 lbs / 42-49 kg", value: 100 },
      { text: "108-125 lbs / 49-57 kg", value: 116 },
      { text: "126-147 lbs / 57-67 kg", value: 132 },
      { text: "148-174 lbs / 67-79 kg", value: 160 },
      { text: "175-209 lbs / 79-95 kg", value: 190 },
      { text: "≥ 210 lbs / ≥ 95 kg ", value: 230 },
    ],

    bootBrands: [
      "Atomic",
      "Dalbello",
      "Dynafit",
      "Fischer",
      "Head",
      "K2",
      "La Sportiva",
      "Lange",
      "Lowa",
      "Nordica",
      "Rossignol",
      "Roxa",
      "Salomon",
      "Scarpa",
      "Tecnica",
      "Other",
    ],

    soleTypes: [
      "Alpine: ISO 5355",
      "Touring: ISO 9523",
      "GripWalk: ISO 23223",
      "Other",
    ],

    ruleRequired: v => !!v || "This field is required",
    ruleSole: v => (v > 200 && v < 400) || "Please enter a valid sole length in mm",
  }),
  computed: {
    // Vuex is convoluted to alter values. This plugin simplifies direct binding to object properties in the store.
    ...mapFields([
      "skierInfo.Type_of_Skier",
      "skierInfo.Height",
      "skierInfo.Weight",
      "skierInfo.Age",
      "skierInfo.Boot_Make",
      "skierInfo.Sole",
      "skierInfo.Sole_Type",
      "skierInfo.Indicator_Setting"
    ]),
  },
  async mounted() {
  },
  methods: {
    Calculate() {
      if (!this.$refs.form.validate()) return;

      // For CRM purposes we store the text value of everything.
      // But for the calculator, we need numeric values, so we look them up here.
      const valTypeOfSkier = this.enumTypeOfSkier.find(x => x.text === this.Type_of_Skier).value;
      const valHeight = this.enumHeight.find(x => x.text === this.Height).value;
      const valWeight = this.enumWeight.find(x => x.text === this.Weight).value;
      const indicator = GetIndicator(valHeight, valWeight, valTypeOfSkier, this.Age, this.Sole);
      this.Indicator_Setting = indicator;
      this.$router.push({ name: "CalculatorResult" });
    },
  },
}
</script>
<style scoped lang="scss"></style>
